export const GENDER_OPTIONS = [
  { value: 'MALE', label: 'Masculino' },
  { value: 'FEMALE', label: 'Feminino' },
];

export const MARITAL_STATUS_OPTIONS = [
  { value: 'MARRIED', label: 'Casado' },
  { value: 'NOT_MARRIED', label: 'Solteiro' },
  { value: 'DIVORCED', label: 'Divorciado' },
];

export const STATUS_OPTIONS = [
  { value: 'active', label: 'Ativo' },
  { value: 'inactive', label: 'Inativo' },
  { value: 'pending', label: 'Pendente' },
  { value: 'suspended', label: 'Suspenso' },
  { value: 'blocked', label: 'Bloqueado' },
];

export const initialValues = {
  name: '',
  email: '',
  documentNumber: '',
  phoneNumber: '',
  status: 'active',
  role: 'customer',
  description: 'Residente',
  birth_date: '',
  phone_number: '',
  gender_flag: 'MALE' as const,
  marital_flag: 'SINGLE' as const,
  status_flag: 'ACTIVE' as const,
  nationality: '',
  cnh_number: '',
  cnh_expiration: '',
  unit: '',
  section_name: '',
  password: '',
  confirmPassword: '',
  avatarFile: null,
  imageUrl: '',
  imagePreview: '',
};

export const RESIDENT_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;